import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Box)`
	position: relative;
	max-height: 180px;
	overflow: hidden;
`;

const Gradient = styled(Box)`
	background: linear-gradient(rgba(255, 255, 255, 0) 0%, white 75%);
	top: 120px;
	left: 0;
	width: 100%;
	height: 60px;
	position: absolute;
	display: flex;
	align-items: flex-end;
	justify-content: center;
`;

const More = styled.a`
	cursor: pointer;
	text-decoration: underline;
	color: ${(props) => props.theme.colors.primary};

	&:hover {
		text-decoration: none;

		&:active {
			color: black;
		}
	}
`;

export default function Clip(
	props: PropsWithChildren<{
		onClick: () => void;
	}>,
) {
	const { t } = useTranslation();

	return (
		<Container>
			{props.children}
			<Gradient>
				<More onClick={props.onClick}>{t('common.showMore')}</More>
			</Gradient>
		</Container>
	);
}
